import { formatAddress } from '~/lib/address-format';
import { ProductAddress } from '../../adapters/product-types';
import { P2GGrid, P2GText } from '@parcel2go/core-ui';

type ProductItemAddressProps = {
  address: ProductAddress;
  title: string;
  icon: React.ReactNode;
};

export function ProductItemAddress({ address, title, icon }: ProductItemAddressProps) {
  return (
    <P2GGrid container wrap="nowrap" spacing={2}>
      <P2GGrid item>{icon}</P2GGrid>
      <P2GGrid item>
        <P2GGrid container direction="column">
          <P2GGrid item>
            <P2GText color="textSecondary" variant="body1" fontWeight="bold">
              {title}
            </P2GText>
          </P2GGrid>
          <P2GGrid item>
            <P2GText variant="body2" data-sentry-mask>
              {formatAddress(address)}
            </P2GText>
          </P2GGrid>
        </P2GGrid>
      </P2GGrid>
    </P2GGrid>
  );
}
